import 'angular:locale/data:pl-PL';
import './apps/halvo-pl/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "pl-PL";
